import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  IUpdateUserDepartmentPayload,
  ActionType,
  UpdateUserDepartmentResponse,
} from "models/userListBusiness/updateUserDepartment";
import { httpStatus } from "configs/httpStatus";
import { updateUserDepartment } from "services/userListBusiness";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./updateUserDepartmentActions";

function* updateUserDepartmentSaga({
  payload,
}: {
  payload: IUpdateUserDepartmentPayload;
}) {
  try {
    const response: UpdateUserDepartmentResponse = yield call(
      updateUserDepartment,
      payload
    );
    if (
      response.status === httpStatus.StatusOK ||
      response.status === httpStatus.StatusCreated ||
      response.status === httpStatus.StatusUnprocessableEntity
    ) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onUpdateUserDepartmentWatcher() {
  yield takeLatest(
    ActionType.UPDATE_USER_DEPARTMENT as any,
    updateUserDepartmentSaga
  );
}

export default [fork(onUpdateUserDepartmentWatcher)];
